(function ($, window, document, undefined) {
	$(function () {
		/**
		 *  Rolls slider
		 */
		function rollsSlider() {
			if($(".slider-1").length) {
				const topSlider = new Splide(".slider-1", {
					type: "loop",
					width: "100vw",
					autoWidth: true,
					clones: 8,
					gap: 17,
					arrows: false,
					pagination: false,
					autoScroll: {
						speed: .3,
					},
				});
				topSlider.mount(window.splide.Extensions);
			}
			if($(".slider-2").length) {
				const bottomSlider = new Splide(".slider-2", {
					type: "loop",
					width: "100vw",
					autoWidth: true,
					clones: 8,
					gap: 17,
					arrows: false,
					pagination: false,
					autoScroll: {
						speed: -.3,
					},
				});
				bottomSlider.mount(window.splide.Extensions);
			}
		}

		function init() {
			rollsSlider();
		}

		init();
	});
})(jQuery, window, document);
